/**
 * Show/hide affordance for a password input: wraps the input and overlays a
 * toggle button. Keeping the value out of session recordings is the input's
 * own concern — see the `data-private` note in `formik-input.component.tsx`.
 */
import React from 'react';
import styled from 'styled-components';

// Material UI
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const RevealWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  /* Grow to fill: as a row flex item the input no longer inherits the stretch
     it got as a direct FormControl child, and padding keeps text off the toggle. */
  & > input {
    flex: 1 1 auto;
    min-width: 0;
    padding-right: 36px;
  }

  & > button {
    position: absolute;
    right: 2px;
    color: rgba(0, 0, 0, 0.54);
  }
`;

interface IPasswordRevealProps {
  revealed: boolean;
  onToggle: () => void;
}

export const PasswordReveal: React.FC<IPasswordRevealProps> = ({ revealed, onToggle, children }) => (
  <RevealWrap>
    {children}
    <IconButton
      type="button"
      size="small"
      onClick={onToggle}
      aria-label={revealed ? 'Hide password' : 'Show password'}
      aria-pressed={revealed}
    >
      {revealed ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
    </IconButton>
  </RevealWrap>
);
